// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --sebrae-black: #000000;
  --sebrae-blue: #005eb8;
  --sebrae-light-gray: #f5f7fa;
  --sebrae-light-gray-2: #e0e5eb;
  --sebrae-white: #ffffff;
  --sebrae-white-2: #f5f5f5;
  --sebrae-purple: #994599;
  --sebrae-light-blue: #5c8fd6;
  --sebrae-blue-2: #0f438a;
  --sebrae-blue-3: #0024a9;
  --sebrae-dark-blue: #142e52;
  --sebrae-dark-blue-2: #0a1729;
  --sebrae-cyan: #14adcc;
  --sebrae-blue-4: #0e778b;
  --sebrae-blue-5: #094f5d;
  --sebrae-gray: #243342;
  --sebrae-red: #bf303c;
  --font-alegreya: "Alegreya Sans";
  --font-lato: "Lato";
}

body {
  font-family: Lato, "Alegreya Sans", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif !important;
  font-weight: 400;
  background-color: var(--sebrae-white-2);
}
body * {
  box-sizing: border-box !important;
}

main {
  min-height: 100vh;
  padding-top: 56px;
}
@media screen and (min-width: 560px) {
  main {
    padding-top: 0;
    padding-left: 70px;
  }
}

img {
  user-drag: none;
  user-select: none;
  -moz-user-select: none;
  -webkit-user-drag: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  max-width: 100%;
}

.container {
  margin: 0 auto;
  padding: 0 16px;
  width: 100%;
  max-width: 100%;
}

button,
a {
  cursor: pointer;
}

strong {
  font-weight: 700 !important;
}

.btn-without-style {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  outline: none;
}

.mt-0 {
  margin-top: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.border-none {
  border: none !important;
}

.BaSe--helper-button-container button {
  padding: 0 !important;
}
.BaSe--input {
  margin-bottom: 15px;
}
.BaSe--input-label, .BaSe--input-sub-label {
  color: var(--sebrae-gray) !important;
  font-weight: 400 !important;
}
.BaSe--input-sub-label {
  font-size: 11px !important;
  font-style: normal !important;
}
.BaSe--input-input {
  width: 100% !important;
}
.BaSe--input-wrapper-label {
  z-index: auto !important;
}
.BaSe--input .BaSe--popover .BaSe--small1 {
  white-space: pre-wrap;
}
.BaSe--popover-card div:first-child small {
  display: block;
  width: calc(100% - 10px);
  margin-bottom: 5px;
}
.BaSe--popover-card div:last-child {
  color: var(--sebrae-gray);
}
.BaSe--popover-card div:last-child * {
  color: inherit !important;
}

.wrapper-select {
  position: relative;
  width: 100%;
}
.wrapper-select .BaSe--select {
  margin-bottom: 15px;
}
.wrapper-select .BaSe--select label {
  color: var(--sebrae-gray) !important;
  font-weight: 400 !important;
}
.wrapper-select .BaSe--select label:last-of-type {
  font-size: 11px !important;
  font-style: normal !important;
}
.wrapper-select .BaSe--select-input {
  width: 100%;
}
.wrapper-select .BaSe--select ul {
  margin: 5px 0;
}
.wrapper-select .BaSe--select ul p {
  margin: 0 !important;
}

.inputs-blue .BaSe--input {
  color: var(--sebrae-blue);
}
.inputs-blue .BaSe--input label,
.inputs-blue .BaSe--input input {
  color: inherit !important;
}
.inputs-blue .BaSe--input input {
  border: 1px solid #8fb8ef !important;
  background: #cfe2fc !important;
}

.input-error-message .error-message {
  display: none;
  margin-top: 5px;
  font-size: 13px;
  font-weight: 400;
}
.input-error-message.invalid {
  color: var(--sebrae-red);
}
.input-error-message.invalid label,
.input-error-message.invalid input {
  color: var(--sebrae-red) !important;
}
.input-error-message.invalid input {
  background: #f3d8da !important;
  border-color: var(--sebrae-red) !important;
}
.input-error-message.invalid .error-message {
  display: block;
}

.Toastify__toast-body {
  align-items: flex-start;
}
.Toastify__toast-icon {
  width: 24px;
}
.Toastify__toast--success {
  background: #ebfaf0;
}
.Toastify__toast--success .toast-content h3 {
  color: #00662a !important;
}
.Toastify__toast--error {
  background: #ffeae5;
}
.Toastify__toast--error .toast-content h3 {
  color: #b22400 !important;
}
.Toastify .toast-content h3 {
  color: #394d60;
  font-family: var(--font-lato);
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}
.Toastify .toast-content p {
  display: block;
  color: #394d60;
  font-family: var(--font-lato);
  font-size: 13px;
  font-weight: 400;
  margin: 2px 0;
  line-height: 1.2;
}

form input[disabled],
form select[disabled] {
  cursor: not-allowed !important;
}

.react-datepicker__month--disabled {
  opacity: 0.65;
  cursor: not-allowed;
  box-shadow: none !important;
}

.new-logo {
  width: 200px;
  object-fit: contain;
  margin-bottom: 50px;
  display: none;
}
@media screen and (min-width: 560px) {
  .new-logo {
    display: block;
  }
}
@media screen and (min-width: 1280px) {
  .new-logo {
    width: 265px;
    margin-bottom: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;EACA,sBAAA;EACA,4BAAA;EACA,8BAAA;EACA,uBAAA;EACA,yBAAA;EACA,wBAAA;EACA,4BAAA;EACA,wBAAA;EACA,wBAAA;EACA,2BAAA;EACA,6BAAA;EACA,sBAAA;EACA,wBAAA;EACA,wBAAA;EACA,sBAAA;EACA,qBAAA;EACA,gCAAA;EACA,mBAAA;AACF;;AAEA;EAEI,0GAAA;EAEA,gBAAA;EAEF,uCAAA;AAFF;AAIE;EACE,iCAAA;AAFJ;;AAKA;EACE,iBAAA;EACA,iBAAA;AAFF;AAIE;EAJF;IAKI,cAAA;IACA,kBAAA;EADF;AACF;;AAGA;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;AAAF;;AAGA;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAAF;;AAEA;;EAEE,eAAA;AACF;;AACA;EACE,2BAAA;AAEF;;AAAA;EACE,YAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;AAGF;;AADA;EACE,wBAAA;AAIF;;AAFA;EACE,2BAAA;AAKF;;AAHA;EACE,uBAAA;AAMF;;AAFI;EACE,qBAAA;AAKN;AAFE;EACE,mBAAA;AAIJ;AAFI;EAEE,oCAAA;EACA,2BAAA;AAGN;AADI;EAEI,0BAAA;EACA,6BAAA;AAER;AACI;EACE,sBAAA;AACN;AACI;EACE,wBAAA;AACN;AAEM;EACE,qBAAA;AAAR;AAMM;EACE,cAAA;EACA,wBAAA;EACA,kBAAA;AAJR;AAOI;EACE,yBAAA;AALN;AAOM;EACE,yBAAA;AALR;;AAUA;EACE,kBAAA;EACA,WAAA;AAPF;AASE;EACE,mBAAA;AAPJ;AASI;EACE,oCAAA;EACA,2BAAA;AAPN;AASM;EAEI,0BAAA;EACA,6BAAA;AARV;AAYI;EACE,WAAA;AAVN;AAYI;EACE,aAAA;AAVN;AAYM;EACE,oBAAA;AAVR;;AAgBE;EACE,yBAAA;AAbJ;AAeI;;EAEE,yBAAA;AAbN;AAeI;EACE,oCAAA;EACA,8BAAA;AAbN;;AAkBE;EACE,aAAA;EACA,eAAA;EAEE,eAAA;EACA,gBAAA;AAhBN;AAmBE;EACE,wBAAA;AAjBJ;AAmBI;;EAEE,mCAAA;AAjBN;AAmBI;EACE,8BAAA;EACA,0CAAA;AAjBN;AAmBI;EACE,cAAA;AAjBN;;AAuBI;EACE,uBAAA;AApBN;AAsBI;EACE,WAAA;AApBN;AAsBI;EACE,mBAAA;AApBN;AAsBM;EACE,yBAAA;AApBR;AAuBI;EACE,mBAAA;AArBN;AAuBM;EACE,yBAAA;AArBR;AA2BI;EACE,cAAA;EAEE,6BAAA;EACA,eAAA;EACA,gBAAA;EAEF,gBAAA;AA3BN;AA6BI;EACE,cAAA;EACA,cAAA;EAEE,6BAAA;EACA,eAAA;EACA,gBAAA;EAEF,aAAA;EACA,gBAAA;AA7BN;;AAoCI;;EACE,8BAAA;AAhCN;;AAoCA;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;AAjCF;;AAmCA;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AAhCF;AAkCE;EANF;IAOI,cAAA;EA/BF;AACF;AAiCE;EAVF;IAWI,YAAA;IACA,mBAAA;EA9BF;AACF","sourcesContent":[":root {\n  --sebrae-black: #000000;\n  --sebrae-blue: #005eb8;\n  --sebrae-light-gray: #f5f7fa;\n  --sebrae-light-gray-2: #e0e5eb;\n  --sebrae-white: #ffffff;\n  --sebrae-white-2: #f5f5f5;\n  --sebrae-purple: #994599;\n  --sebrae-light-blue: #5c8fd6;\n  --sebrae-blue-2: #0f438a;\n  --sebrae-blue-3: #0024a9;\n  --sebrae-dark-blue: #142e52;\n  --sebrae-dark-blue-2: #0a1729;\n  --sebrae-cyan: #14adcc;\n  --sebrae-blue-4: #0e778b;\n  --sebrae-blue-5: #094f5d;\n  --sebrae-gray: #243342;\n  --sebrae-red: #bf303c;\n  --font-alegreya: \"Alegreya Sans\";\n  --font-lato: \"Lato\";\n}\n\nbody {\n  font: {\n    family: Lato, \"Alegreya Sans\", \"Open Sans\", \"Helvetica Neue\", Helvetica,\n      Arial, sans-serif !important;\n    weight: 400;\n  }\n  background-color: var(--sebrae-white-2);\n\n  * {\n    box-sizing: border-box !important;\n  }\n}\nmain {\n  min-height: 100vh;\n  padding-top: 56px;\n\n  @media screen and (min-width: 560px) {\n    padding-top: 0;\n    padding-left: 70px;\n  }\n}\nimg {\n  user-drag: none;\n  user-select: none;\n  -moz-user-select: none;\n  -webkit-user-drag: none;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  max-width: 100%;\n}\n\n.container {\n  margin: 0 auto;\n  padding: 0 16px;\n  width: 100%;\n  max-width: 100%;\n}\nbutton,\na {\n  cursor: pointer;\n}\nstrong {\n  font-weight: 700 !important;\n}\n.btn-without-style {\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  outline: none;\n}\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.border-none {\n  border: none !important;\n}\n.BaSe {\n  &--helper-button-container {\n    button {\n      padding: 0 !important;\n    }\n  }\n  &--input {\n    margin-bottom: 15px;\n\n    &-label,\n    &-sub-label {\n      color: var(--sebrae-gray) !important;\n      font-weight: 400 !important;\n    }\n    &-sub-label {\n      font: {\n        size: 11px !important;\n        style: normal !important;\n      }\n    }\n    &-input {\n      width: 100% !important;\n    }\n    &-wrapper-label {\n      z-index: auto !important;\n    }\n    .BaSe--popover {\n      .BaSe--small1 {\n        white-space: pre-wrap;\n      }\n    }\n  }\n  &--popover-card {\n    div:first-child {\n      small {\n        display: block;\n        width: calc(100% - 10px);\n        margin-bottom: 5px;\n      }\n    }\n    div:last-child {\n      color: var(--sebrae-gray);\n\n      * {\n        color: inherit !important;\n      }\n    }\n  }\n}\n.wrapper-select {\n  position: relative;\n  width: 100%;\n\n  .BaSe--select {\n    margin-bottom: 15px;\n\n    label {\n      color: var(--sebrae-gray) !important;\n      font-weight: 400 !important;\n\n      &:last-of-type {\n        font: {\n          size: 11px !important;\n          style: normal !important;\n        }\n      }\n    }\n    &-input {\n      width: 100%;\n    }\n    ul {\n      margin: 5px 0;\n\n      p {\n        margin: 0 !important;\n      }\n    }\n  }\n}\n.inputs-blue {\n  .BaSe--input {\n    color: var(--sebrae-blue);\n\n    label,\n    input {\n      color: inherit !important;\n    }\n    input {\n      border: 1px solid #8fb8ef !important;\n      background: #cfe2fc !important;\n    }\n  }\n}\n.input-error-message {\n  .error-message {\n    display: none;\n    margin-top: 5px;\n    font: {\n      size: 13px;\n      weight: 400;\n    }\n  }\n  &.invalid {\n    color: var(--sebrae-red);\n\n    label,\n    input {\n      color: var(--sebrae-red) !important;\n    }\n    input {\n      background: #f3d8da !important;\n      border-color: var(--sebrae-red) !important;\n    }\n    .error-message {\n      display: block;\n    }\n  }\n}\n.Toastify {\n  &__toast {\n    &-body {\n      align-items: flex-start;\n    }\n    &-icon {\n      width: 24px;\n    }\n    &--success {\n      background: #ebfaf0;\n\n      .toast-content h3 {\n        color: #00662a !important;\n      }\n    }\n    &--error {\n      background: #ffeae5;\n\n      .toast-content h3 {\n        color: #b22400 !important;\n      }\n    }\n  }\n\n  .toast-content {\n    h3 {\n      color: #394d60;\n      font: {\n        family: var(--font-lato);\n        size: 16px;\n        weight: 700;\n      }\n      line-height: 1.2;\n    }\n    p {\n      display: block;\n      color: #394d60;\n      font: {\n        family: var(--font-lato);\n        size: 13px;\n        weight: 400;\n      }\n      margin: 2px 0;\n      line-height: 1.2;\n    }\n  }\n}\nform {\n  input,\n  select {\n    &[disabled] {\n      cursor: not-allowed !important;\n    }\n  }\n}\n.react-datepicker__month--disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n  box-shadow: none !important;\n}\n.new-logo {\n  width: 200px;\n  object-fit: contain;\n  margin-bottom: 50px;\n  display: none;\n\n  @media screen and (min-width: 560px) {\n    display: block;\n  }\n\n  @media screen and (min-width: 1280px) {\n    width: 265px;\n    margin-bottom: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
